module.exports = __webpack_public_path__ + "static/media/immigration.73d83316.svg";